import { Dispatch, SetStateAction } from "react";

export function checkInput(
  e: string,
  id: string
) {
  console.log(e);
  console.log(id);
  if (e === "CONFIRM") {
    document
      .getElementById(id)
      ?.setAttribute("disabled", "false");
  } else {
    document
      .getElementById(id)
      ?.setAttribute("disabled", "true");
  }
}

export function checkInputFlipBoolean(
  e: string,
  boolValue: Dispatch<SetStateAction<boolean>>
) {
  if (e === "CONFIRM") {
    boolValue(false);
  } else {
    boolValue(true);
  }
}
